import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogContent, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'gtw-ng-action-click',
    templateUrl: './ng-really-click.component.html',
    styleUrls: ['./ng-really-click.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NgReallyActionComponent implements OnInit, AfterViewInit {
  constructor(public diagRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any) { }
  ngAfterViewInit(): void {
    console.log('this', this);
  }
  @Input()
  message: any;

  @Input()
  header: any;

  isIssueChangeAction: any;
  isTypeOk: any;
  globalIssue: any
  rowIssue: any;

  @Input()
  type: 'inline' | 'modal' = 'modal';

  @Output()
  onNgReallyClose: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    console.log('this', this);
    this.message = this.message ?? this.data.message;
    this.header = this.header ?? this.data.header;
    this.isIssueChangeAction = this.data.isIssueChangeAction;
    this.isTypeOk = this.data.ngReallyOk;
    this.globalIssue = this.data.globalIssue;
    this.rowIssue = this.data.rowIssue;

  }
  cancel() {
    if (this.type === 'inline') {
      this.onNgReallyClose.emit(false);
    }

    this.diagRef.close();
  }
  confirm() {
    if (this.type === 'inline') {
      this.onNgReallyClose.emit(true);
    }

    this.diagRef.close(true);

  }
  saveWithIssueId(isGlobalIssues: any) {
    this.diagRef.close({ 'isGlobalIssue': isGlobalIssues });

  }

}
